import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  articleId: string;
}

export default function FavoriteButton({ articleId }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(articleId);

  return (
    <button
      type="button"
      onClick={() => toggleFavorite(articleId)}
      aria-pressed={active}
      className={`flex items-center gap-1.5 whitespace-nowrap rounded-md border px-3.5 py-2 text-sm font-medium transition-colors ${
        active
          ? "border-accent-400 bg-accent-100 text-accent-900"
          : "border-background-300 text-foreground-700 hover:border-accent-300 hover:text-accent-800"
      }`}
    >
      <i className={active ? "ri-bookmark-fill" : "ri-bookmark-line"} />
      {active ? "已收藏" : "收藏"}
    </button>
  );
}